export const ASSIGNMENT_FIRM_DETAIL_FIELDS = [
  'name',
  'corporateIdentity',
  'address',
  'zipcode',
  'city',
  'phone',
  'email',
] as const;

export type UserAssignmentFirmDetails = Record<`assignment.${(typeof ASSIGNMENT_FIRM_DETAIL_FIELDS)[number]}`, string>;
